import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SentryService } from 'sentry';
import { CustomError, HttpNoNetworkConnectionError } from 'utils';

@Injectable({
  providedIn: 'root',
})
export class MonitoringService {
  private sentryService = inject(SentryService);
  private httpMessagesToSkip: string[] = [
    'identity/selfcare',
    'identity/pos',
    'Http failure response for (unknown url)',
    'Failed to fetch dynamically imported module',
    ': 0 undefined',
  ];
  private httpErrorsToSkip: string[] = [
    'ERR_CUSTOMER_FOUND_LOGIN_REQUIRED',
    'ERR_CREDITCHECK_LIGHT_PRODUCT_ONLY',
    'ERR_INVALID_CREDIT_CHECK_DATA',
    'ERR_CREDITCHECK_BAD_CUSTOMER',
    'ERR_CREDITCHECK_MANUAL_CHECK_REQUIRED',
    'ERR_CREDITCHECK_ALLOWED_SUB_EXCEEDED',
    'ERR_PREPAID_MAX_REACHED',
    'ERR_RECORD_NOT_FOUND',
    'ERR_EMAIL_EXISTS',
    'ERR_INVALID_USERNAME_OR_PASSWORD',
    'ERR_INVALID_SECRET_OR_CODE',
    'ERR_CANNOT_PORT_FROM_SAME_BRAND',
    'ERR_INVALID_TOKEN',
    'ERR_PROVIDER_INFO_NOT_FOUND',
    'ERR_ACCOUNT_NOT_FOUND',
    'ERR_USE_OTHER_SEARCH_OPTION',
    'ERR_ORDER_ALREADY_IN_PROGRESS',
    'ERR_PRODUCTS_NOT_AVAILABLE',
    'ERR_PASSWORD_NOT_MATCHED',
    'ERR_PASSWORD_REQUIRED',
  ];
  private errorNamesToSkip: string[] = ['ChunkLoadError'];

  public log(error: CustomError) {
    if (this.shouldSkipLog(error)) {
      return;
    }

    this.sentryService.captureException(error);
  }

  private shouldSkipLog(error: CustomError): boolean {
    return (
      error instanceof HttpNoNetworkConnectionError ||
      (error instanceof HttpErrorResponse &&
        this.httpErrorsToSkip.some(errorToSkip => error.error?.error?.includes(errorToSkip))) ||
      ((error instanceof Error || error instanceof HttpErrorResponse) &&
        (this.httpMessagesToSkip.some(messageToSkip => error.message?.includes(messageToSkip)) ||
          this.errorNamesToSkip.some(nameToSkip => error.name?.includes(nameToSkip))))
    );
  }
}
